import Alpine from "alpinejs";

Alpine.data('gallery', (media) => ({
  media: media,

  get hasTrack() {
    return this.media.length > 1;
  },

  init() {
    this.media = this.media
      .sort((a, b) => a.position - b.position)
      .map((item, index) => {
        item.active = index === 0;
        item.src.src = `${item.preview_image.src}&width=800`;
        item.preview_image.src = `${item.preview_image.src}&width=200`;
        return item;
      });

    /**
     * Safari struggles to open the dialog, chrome struggles to close it!
     * I think it's something to do with it be grid?
     * So just redraw when those events happen
     */
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'open') {
          this._redraw();
        }
      });
    }).observe(this.$root, { attributes: true });
  },
  setActiveFromVariant() {
    let variant = this.$event.detail;

    this.setActive(
      this.media.findIndex((item) => item.id === variant.featured_media.id)
    );
  },
  setActive(index) {
    this.media = this.media.map((item, mediaIndex) => {
      item.active = mediaIndex === index;
      return item;
    });
    
    const child = this.$refs.track.children[index];
    if (child) {
      this.$refs.track.scrollTo({
        left: index === 0 ? 0 : (
          this.$refs.track.scrollLeft + 
          (child.getBoundingClientRect().left - this.$refs.track.getBoundingClientRect().left)
        ),
        behavior: 'smooth',
      });
    }
  },
  close() {
    this.$root.close();
  },
  previousImage() {
    let currentIndex = this.media.findIndex((item) => item.active);
    let previousIndex = (currentIndex - 1 + this.media.length) % this.media.length;
    this.setActive(previousIndex);
  },
  nextImage() {
    let currentIndex = this.media.findIndex((item) => item.active);
    let nextIndex = (currentIndex + 1) % this.media.length;
    this.setActive(nextIndex);
  },
  _redraw() {
    this.$el.style.display = 'none';
    this.$nextTick(() => {
      this.$el.style.display = '';
    });
  }
}));